import React from 'react';
import PropTypes from 'prop-types';

import { Link, RowContainer } from '../../shared/styles';
import {
  ActionColumn,
  DescriptionColumn,
  NameColumn,
  SlugColumn,
} from './styles';

export default function ContentFormatType({ contentFormatType }) {
  const {
    id,
    name,
    slug,
    description,
  } = contentFormatType;

  return (
    <RowContainer>
      <NameColumn>{name}</NameColumn>
      <SlugColumn>{slug}</SlugColumn>
      <DescriptionColumn>{description}</DescriptionColumn>
      <ActionColumn>
        <Link href={`/lwadmin/content_format_type/${id}/edit`}>Edit</Link>
      </ActionColumn>
    </RowContainer>
  );
}

ContentFormatType.propTypes = {
  contentFormatType: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
};
